import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {UserApi, LocaleApi} from 'services/network/api';
import {LocaleAction} from 'services/redux/actions';
import {checkUserExist} from 'services/user';

import {Notification, Validator, Spinner} from 'components/common/uiKit';
import {CircularProgress} from "@material-ui/core";

class SelectLanguage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            selected: 0,
            loading: true
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        LocaleApi.GetLocales()
            .then(res => {
                if (res && res.status == 200) {
                    const {data} = res;

                    const {locale} = this.props;
                    const selected = locale && locale.id ? locale.id : data[0].id;
                    this.setState({data, selected});
                }
            }).finally(() => {
            this.setState({loading: false});
        });
    }


    _handleChange = (id) => {
        const {data} = this.state;
        let locale = data.find(x => x.id == id);
        if (typeof (locale.translation) == 'string')
            locale.translation = JSON.parse(locale.translation);

        const {actions} = this.props;
        actions.setLocale(locale);

        this.setState({selected: id});
        //this.validator = Validator(locale.abbreviation);


        if (checkUserExist()) {
            this.updateLocale(id);
        }
    };

    updateLocale(localeId) {
        UserApi.UpdateLocale({localeId})
            .then(res => {
                if (res && res.status == 200) {
                    Notification('success', 'Succeed');

                    const {callback} = this.props;
                    if(callback)
                        callback()
                }
            });
    }

    render() {
        const {data, selected, loading} = this.state;
        const {size, locale} = this.props;

        if (loading) {
            return (
                <div className='d-flex justify-content-center align-items-center'>
                <Spinner size={32}/>
                </div>
            );
        }

        if (size && size == 'small') {
            return (
                <>
                    <div className='mt-2 mb-2 d-flex'>
                        <div className='d-flex flex-grow-1 align-items-center justify-content-around'>
                            {data && data.map((item, index) => {
                                let classes = 'pt-1';
                                classes += item.id == selected ? ' text-success' : '';
                                return (
                                    <div className='d-flex flex-column align-items-center'
                                         onClick={this._handleChange.bind(this, item.id)}>
                                <span className={`flag-icon flag-icon-${item.icon} flag-icon-squared font-32`}
                                      style={{borderRadius: '50%'}}></span>
                                        {
                                            selected == item.id &&
                                            <i className='fa fa-check text-success font-32' style={{
                                                position: 'absolute',
                                                borderRadius: '50%',
                                                backgroundColor: 'white',
                                                opacity: 0.6
                                            }}/>
                                        }
                                        <span className={classes}>{item.name}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </>
            );
        }

        return (
            <>
                <div className='mt-2 mb-2 d-flex'
                     style={{borderStyle: 'solid', borderWidth: 3, borderColor: '#eee', borderRadius: 10}}>
                    <div style={{backgroundColor: '#eee', padding: 20}}>
                        <i className='fa fa-language font-40'/>
                    </div>
                    <div className='d-flex flex-grow-1 align-items-center justify-content-around'>
                        {data && data.map((item, index) => {
                            let classes = 'pt-1';
                            classes += item.id == selected ? ' text-success' : '';

                            return (
                                <div className='d-flex flex-column align-items-center'
                                     onClick={this._handleChange.bind(this, item.id)}>
                                <span className={`flag-icon flag-icon-${item.icon} flag-icon-squared font-40`}
                                      style={{borderRadius: '50%'}}></span>
                                    {
                                        selected == item.id &&
                                        <i className='fa fa-check text-success font-40' style={{
                                            position: 'absolute',
                                            borderRadius: '50%',
                                            backgroundColor: 'white',
                                            opacity: 0.6
                                        }}/>
                                    }
                                    <span className={classes}>{item.name}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </>
        );
    }
}

const ActionCreators = Object.assign({}, LocaleAction);

const mapDispatchToProps = dispatch => {
    return ({
        actions: bindActionCreators(ActionCreators, dispatch)
    });
};

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectLanguage);
